import { FuuzeText } from '@fuuze/shared';
import type { JSXElementConstructor, ReactElement, ReactNode, SVGProps } from 'react';
import type { IconType } from 'react-icons';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { NavLink, type NavLinkProps } from 'react-router-dom';
import styles from './fuuze-nav-link.module.css';

type LeftNavLinkProps = {
  Icon: IconType | JSXElementConstructor<SVGProps<SVGSVGElement>>;
  active?: boolean;
  external?: boolean;
  // onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  path?: string;
  // state?: any;
  title: ReactNode;
  showUnderline?: boolean;
} & Omit<NavLinkProps, 'to' | 'title'>;

export function FuuzeNavLink({
  Icon,
  active,
  external,
  onClick,
  path,
  state,
  title,
  showUnderline,
  ...props
}: LeftNavLinkProps) {
  return (
    <NavLink
      className={styles.NavLink}
      to={path || '#'}
      onClick={onClick}
      target={external ? '_blank' : '_self'}
      state={state}
      data-active={active}
      style={{
        textDecoration: showUnderline ? 'auto' : 'none',
      }}
      {...props}
    >
      <Icon className={styles.Icon} style={{ marginRight: title ? 8 : 0 }} />
      {typeof title === 'string' ? (
        <FuuzeText as='span' className={styles.Title}>
          {title}
        </FuuzeText>
      ) : (
        title
      )}
      {external && <HiOutlineExternalLink style={{ fill: 'unset', marginLeft: 'auto' }} size={20} />}
    </NavLink>
  );
}
